import { useNavigate } from 'react-router-dom';

const APP_NAME    = '[App Name]';
const COMPANY     = '[Company Name]';
const CONTACT     = '[Contact Email]';
const EFFECTIVE   = '[Effective Date]';

export default function Terms() {
  const navigate = useNavigate();

  const h2 = { fontSize: '1.05rem', fontWeight: 700, color: 'var(--text)', margin: '32px 0 10px' };
  const p  = { fontSize: '0.88rem', color: 'var(--muted)', lineHeight: 1.8, marginBottom: 12 };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: '48px 24px 80px' }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>

        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer',
            fontSize: '0.85rem', padding: 0, marginBottom: 32, display: 'flex', alignItems: 'center', gap: 6,
          }}
        >
          ← Back
        </button>

        <h1 style={{ fontSize: '1.8rem', fontWeight: 800, color: 'var(--text)', marginBottom: 8 }}>
          Terms of Service
        </h1>
        <p style={{ ...p, marginBottom: 32 }}>
          Effective date: {EFFECTIVE} · {APP_NAME} is operated by {COMPANY}.
        </p>

        <h2 style={h2}>1. Acceptance of Terms</h2>
        <p style={p}>
          By accessing or using {APP_NAME} ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service. These terms apply to all users, including agency accounts and any end clients whose data is processed through the Service.
        </p>

        <h2 style={h2}>2. Description of Service</h2>
        <p style={p}>
          {APP_NAME} provides AI visibility scanning and reporting tools that analyse how businesses appear in AI-powered search engines including ChatGPT, Google Gemini and Perplexity. The Service includes scan reports, PDF generation, scheduled monitoring, and white-label reporting capabilities.
        </p>

        <h2 style={h2}>3. Account Registration</h2>
        <p style={p}>
          You must provide accurate information when creating an account. You are responsible for maintaining the confidentiality of your credentials and for all activity that occurs under your account. You must notify us immediately of any unauthorised use of your account.
        </p>

        <h2 style={h2}>4. Subscription and Payment</h2>
        <p style={p}>
          The Service is offered on a subscription basis. Fees are charged in advance on a monthly basis. All payments are processed securely by Stripe. By subscribing, you authorise {COMPANY} to charge your payment method on a recurring basis.
        </p>
        <p style={p}>
          You may cancel your subscription at any time through the billing portal. Cancellation takes effect at the end of your current billing period — you retain access until then. We do not offer refunds for partial billing periods.
        </p>
        <p style={p}>
          We reserve the right to change pricing with 30 days' notice. Continued use after a price change constitutes acceptance of the new pricing.
        </p>

        <h2 style={h2}>5. Free Trial</h2>
        <p style={p}>
          New accounts receive a 7-day free trial. No payment method is required to start a trial. At the end of the trial period, access to paid features will be restricted until a subscription is activated. We reserve the right to limit or end trial access at our discretion.
        </p>

        <h2 style={h2}>6. Acceptable Use</h2>
        <p style={p}>
          You agree not to misuse the Service. Prohibited uses include: attempting to circumvent usage quotas; using the Service to generate spam or misleading reports; reverse engineering or reselling the Service without authorisation; or any use that violates applicable law.
        </p>

        <h2 style={h2}>7. Intellectual Property</h2>
        <p style={p}>
          {COMPANY} retains all intellectual property rights in the Service, including the software, design, and underlying algorithms. You retain ownership of data you input into the Service. You grant {COMPANY} a limited licence to process that data solely to provide the Service.
        </p>
        <p style={p}>
          Reports and PDFs generated by the Service may be shared with your clients. You may not redistribute or resell the underlying software or platform.
        </p>

        <h2 style={h2}>8. Data and Privacy</h2>
        <p style={p}>
          Your use of the Service is also governed by our Privacy Policy. By using the Service, you consent to our collection and use of data as described therein. We process business data (Google Maps listings, AI search results) on your behalf. You are responsible for obtaining any consents required from your end clients.
        </p>

        <h2 style={h2}>9. Availability and Uptime</h2>
        <p style={p}>
          We aim to provide a reliable service but do not guarantee uninterrupted availability. Scheduled maintenance, third-party API outages (including OpenAI, Google, Perplexity), or circumstances beyond our control may affect availability. We are not liable for losses caused by downtime.
        </p>

        <h2 style={h2}>10. Limitation of Liability</h2>
        <p style={p}>
          To the fullest extent permitted by law, {COMPANY} shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits, revenue, data, or goodwill, arising out of your use of or inability to use the Service. Our total liability to you shall not exceed the amount you paid to us in the 3 months preceding the claim.
        </p>

        <h2 style={h2}>11. Disclaimers</h2>
        <p style={p}>
          The Service is provided "as is" without warranties of any kind. AI search results are generated by third-party services and may not be accurate or complete. Scan results represent a snapshot in time and may change. {COMPANY} does not guarantee any specific outcome from use of the Service.
        </p>

        <h2 style={h2}>12. Termination</h2>
        <p style={p}>
          We reserve the right to suspend or terminate your account if you breach these Terms or for any other reason at our discretion, with or without notice. Upon termination, your right to access the Service ceases immediately. We may retain data in accordance with our Privacy Policy.
        </p>

        <h2 style={h2}>13. Changes to Terms</h2>
        <p style={p}>
          We may update these Terms from time to time. We will notify you of material changes by email or in-app notice. Continued use of the Service after changes constitutes acceptance of the revised Terms.
        </p>

        <h2 style={h2}>14. Governing Law</h2>
        <p style={p}>
          These Terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.
        </p>

        <h2 style={h2}>15. Contact</h2>
        <p style={p}>
          For questions about these Terms, contact us at {CONTACT}.
        </p>

      </div>
    </div>
  );
}
